import React from "react";
import "./Home.css";

const Home = () => {
  const isMobile = window.matchMedia("(max-width:600px)").matches;
  return (
    <div className='HomeContainer'>
      <div className='Text'>Herzlich Willkommen bei der Baumschule Helms!</div>
 {     <div className='ClosedNote'>
        Auf Grund der Sommerzeit geänderte Öffnungszeiten vom 29.06. - 14.08.26:
        <br />
        Mo - Fr 8:00 - 12:30 Uhr
      </div>}

{/*  <div className='ClosedNote'>
          Zusätzliche Öffnungszeiten anlässlich des Weihnachtsbaumverkaufs am
          13.12. und 14.12 sowie am 20.12 und 21.12.25 
          <br />
          von 10:00 - 16:00 Uhr
        </div> */}

{/*                <div className='ClosedNote'>
        Der Betrieb ist bis zum 19.01.26 geschlossen.
      </div> */}
       
      <img className='Image' src='home.jpeg' />
      <div className='Text'>
        Öffnungszeiten: {isMobile && <br />} Mo - Fr 8:00 - 12:30 Uhr
      </div>
    </div>
  );
};

export default Home;
